export default "__VITE_ASSET__DtXeMgC1__"